import { DefaultEdgeOptions, Edge, Node } from "reactflow"
import { GraphSelectionModel } from "@features/graph/graphViewModel"
import { graphNodeSelectionStyle } from "@features/graph/node/style/graphNodeSelectionStyle"

export interface GraphNodeChange {
  id: string
  dragging?: boolean
  position?: { x: number; y: number }
  size?: { width: number; height: number }
  selected?: boolean
}

export const graphApplyNodeChanges = (
  nodeChanges: { [key: string]: GraphNodeChange },
  nodeInternals: Map<string, Node>,
) => {
  for (const [_, node] of nodeInternals) {
    node.positionAbsolute = { ...node.position }
    if (nodeChanges[node.id]) {
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      applyNodeChange(node, nodeChanges[node.id])
    }
  }
  return nodeInternals
}

export const graphApplyEdgeChanges = (edges: Edge[], defaultEdgeOptions?: DefaultEdgeOptions) => {
  const nextEdges: Edge[] = []
  edges.forEach((edge) => {
    const newEdge: Edge = { ...defaultEdgeOptions, ...edge }
    if (GraphSelectionModel.childEdges.has(edge.id)) {
      newEdge.className = "gnc-edge-child"
    } else if (GraphSelectionModel.parentEdges.has(edge.id)) {
      newEdge.className = "gnc-edge-parent"
    } else {
      newEdge.className = "gnc-edge"
    }
    nextEdges.push(newEdge)
  })
  return nextEdges
}

const applyNodeChange = (node: Node, change: GraphNodeChange) => {
  if (change.selected !== undefined) {
    node.selected = change.selected
  }

  const exclude = node.data?.display?.exportExcluded ? true : false

  node.className = graphNodeSelectionStyle(!!node.selected, node.id, exclude)
  if (change.size) {
    node.width = change.size.width
    node.height = change.size.height
    if (node.style) {
      node.style = {
        ...node.style,
        width: change.size.width,
        height: change.size.height,
      }
    }
  }
  if (change.position) {
    node.position = change.position
    node.positionAbsolute = change.position
  }
}
